import community from '@src/services/community';
import auth from '@src/services/auth';
import notice from '@src/services/notice';
import my from '@src/services/my';
import blood from '@src/services/blood';
import calendar from '@src/services/calender';

export { auth, community, notice, my, blood, calendar };
